import "core-js/modules/es6.regexp.split";
import _slicedToArray from "/vercel/16327899/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { get, runIfFn } from "@chakra-ui/utils";
import { isSubcomponent, filterUndefined } from "./utils";
import { getComponentDefaults } from "./get-default-props";
/**
 * Gets the base styles of a component based on the
 * theme key in `options`
 */

export function getBaseStyle(props, options) {
  if (!options.themeKey) return undefined;

  var _options$themeKey$spl = options.themeKey.split("."),
      _options$themeKey$spl2 = _slicedToArray(_options$themeKey$spl, 2),
      component = _options$themeKey$spl2[0],
      subComponent = _options$themeKey$spl2[1];
  /**
   * Get the default modifier values defined in theme
   */


  var defaultPropsInTheme = getComponentDefaults(props.theme, component);
  /**
   * Merge the props with defaultProps defined in theme
   * to provider sensible fallbacks
   */

  var computedProps = defaultPropsInTheme ? _extends({}, defaultPropsInTheme, filterUndefined(props)) : props;
  var styleObjectOrFn = get(props.theme, "components." + component + ".baseStyle");
  if (!styleObjectOrFn) return undefined;
  var style = runIfFn(styleObjectOrFn, computedProps);

  if (isSubcomponent(options.themeKey)) {
    style = style[subComponent];
  }

  return style;
}